// lsr-seo-link.service.ts
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LsrSeoLinkService {
    constructor(@Inject(DOCUMENT) private readonly doc: Document) { }

    /**
     * Uppfærir eða býr til <link rel="canonical"> með gefinni slóð.
     * Virkar bæði í SSR og í browser.
     */
    updateCanonicalTag(canonicalUrl: string): void {
        const head = this.doc.head || this.doc.getElementsByTagName('head')[0];
        if (!head) return;

        // --- Canonical ---
        const existingCanon = head.querySelectorAll<HTMLLinkElement>("link[rel='canonical']");
        let canonical = existingCanon.item(0);
        if (!canonical) {
            canonical = this.doc.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            head.appendChild(canonical);
        }
        canonical.setAttribute('href', canonicalUrl);
        // Fjarlægja tvítekningar
        for (let i = 1; i < existingCanon.length; i++) head.removeChild(existingCanon.item(i));

        // --- hreflang="is" alternate ---
        const existingAltIs = head.querySelectorAll<HTMLLinkElement>("link[rel='alternate'][hreflang='is']");
        let altIs = existingAltIs.item(0);
        if (!altIs) {
            altIs = this.doc.createElement('link');
            altIs.setAttribute('rel', 'alternate');
            altIs.setAttribute('hreflang', 'is');
            head.appendChild(altIs);
        }
        altIs.setAttribute('href', canonicalUrl);
        // Fjarlægja tvítekningar
        for (let i = 1; i < existingAltIs.length; i++) head.removeChild(existingAltIs.item(i));
    }
}
